import styled, { breakpoints, css } from '../../styles/theme';
import { ToggleTemplate } from './ToggleTemplate';

const TOGGLE_SIZE = 20;
const BORDER_SIZE = 1;
const TEXT_MARGIN = 8;

export const ToggleStyled = styled(ToggleTemplate)`
    position: relative;
    display: flex;
    flex-direction: ${({ isHorizontal }) => (isHorizontal ? 'row' : 'column')};
    height: ${({ isHorizontal }) => (isHorizontal ? 'auto' : `${TOGGLE_SIZE * 2 + BORDER_SIZE * 2}px`)};
    justify-content: space-around;
    align-items: ${({ isHorizontal }) => (isHorizontal ? 'center' : 'flex-start')};
    flex-wrap: ${({ isHorizontal }) => (isHorizontal ? 'nowrap' : 'wrap')};

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
        `}

    div {
        display: flex;
        flex-direction: column;
    }

    .toggleHandleContainer {
        background: ${({ theme }) => theme.colors.primaryDisabled};
        border-radius: 1rem;
        border: ${BORDER_SIZE}px solid ${({ theme }) => theme.colors.primaryDisabled};
        display: flex;
        width: ${({ isHorizontal }) =>
            isHorizontal ? `${TOGGLE_SIZE * 2 + BORDER_SIZE * 2}px` : `${TOGGLE_SIZE + BORDER_SIZE * 2}px`};
        height: ${({ isHorizontal }) =>
            isHorizontal ? `${TOGGLE_SIZE + BORDER_SIZE * 2}px` : `${TOGGLE_SIZE * 2 + BORDER_SIZE * 2}px`};
        flex: 0 0 ${TOGGLE_SIZE * 2 + BORDER_SIZE * 2}px;
        order: ${({ isHorizontal }) => (isHorizontal ? '2' : '0')};
        margin-left: ${({ isHorizontal }) => (isHorizontal ? `${TEXT_MARGIN}px` : 0)};
        cursor: pointer;
    }

    .toggleHandle {
        box-sizing: border-box;
        transition: 0.25s ease-out all;
        width: ${TOGGLE_SIZE}px;
        height: ${TOGGLE_SIZE}px;
        border-radius: 100%;
        position: relative;
        background-color: ${({ theme }) => theme.colors.primary};
        top: 0;
        left: 0;

        &.toggled {
            top: ${({ isHorizontal }) => (isHorizontal ? '0' : `calc(100% - ${TOGGLE_SIZE}px)`)};
            left: ${({ isHorizontal }) => (isHorizontal ? `calc(100% - ${TOGGLE_SIZE}px)` : '0')};
        }

        ${({ disabled }) =>
            !disabled &&
            css`
                cursor: pointer;
            `}
    }
    .toggleOption {
        cursor: default;
        margin-left: ${({ isHorizontal }) => (isHorizontal ? 0 : `${TEXT_MARGIN}px`)};
        font-weight: ${props => props.theme.fontWeights.textRegular};
        text-transform: uppercase;
        font-size: ${props => props.theme.fontSizes.textBase};

        &.toggleOption-desktop {
            display: none;

            @media (min-width: ${breakpoints.md}px) {
                display: ${({ isCondensed }) => (isCondensed ? 'none' : 'inline')};
            }
        }

        &.toggleOption-mobile {
            display: inline;

            @media (min-width: ${breakpoints.md}px) {
                display: ${({ isCondensed }) => (isCondensed ? 'inline' : 'none')};
            }
        }

        &:nth-child(2) {
            order: ${({ isHorizontal }) => (isHorizontal ? '1' : '0')};
        }

        &:nth-child(3) {
            order: ${({ isHorizontal }) => (isHorizontal ? '3' : '0')};
        }

        &.toggled {
            font-weight: ${props => props.theme.fontWeights.textBold};
        }
    }
`;
